import React from "react";
import PublicNav from "../components/PublicNav";
import Footer from "../components/Footer";

// Ritratto ufficiale Luca Perobelli — Fondatore RX CASA
const LUCA_PHOTO = "https://customer-assets-eiarnc6j.emergentagent.net/job_casa-certificata/artifacts/drsa6ud2_20240929_Perobelli-30.webp";

export default function ChiSiamo() {
  return (
    <div className="paper-bg" data-testid="chi-siamo-page">
      <PublicNav />

      <section className="max-w-[1240px] mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-16">
        <div className="label-uppercase mb-6">Chi siamo</div>
        <h1 className="font-serif text-5xl md:text-7xl leading-[1.02] tracking-tight text-[#3A3D42] max-w-4xl">
          Un terzo<br/>che non vende.
        </h1>
        <p className="text-lg text-[#5C5657] mt-8 max-w-2xl leading-relaxed">
          RX CASA è il garante del Protocollo Pronto alla Vendita.
        </p>
      </section>

      <section className="max-w-[1240px] mx-auto px-6 md:px-10 pb-24 grid md:grid-cols-12 gap-12">
        {/* Colonna foto + firma */}
        <div className="md:col-span-4">
          <div className="border border-[#E6E4E0] p-3 bg-white">
            <img
              src={LUCA_PHOTO}
              alt="Luca Perobelli — Fondatore RX CASA"
              className="w-full aspect-[3/4] object-cover"
              data-testid="luca-photo"
            />
          </div>
          <div className="mt-6">
            <div className="font-serif text-2xl text-[#3A3D42]">Luca Perobelli</div>
            <div className="label-uppercase mt-2">Fondatore · RX CASA</div>
            <p className="text-sm text-[#5C5657] mt-5 leading-relaxed">
              Trent'anni di sviluppo immobiliare, dal cantiere al rogito. Ha costruito, venduto,
              e visto immobili perdere valore in trattativa per un problema che nessuno aveva
              verificato prima della messa sul mercato. Ha creato lo standard che avrebbe voluto trovare.
            </p>
          </div>
        </div>

        {/* Colonna testo */}
        <div className="md:col-span-8 space-y-6 text-[#3A3D42] leading-relaxed">
          <p>
            Non siamo un'agenzia immobiliare. Non vendiamo case. Non le intermediamo. Non prendiamo
            provvigioni sulla trattativa.
          </p>
          <p>
            Facciamo due cose. Verifichiamo un immobile prima che arrivi sul mercato, con criteri
            fissi uguali per tutti. E lo portiamo alla condizione in cui il suo valore è
            riconoscibile — documentato, verificabile, difendibile in trattativa.
          </p>
          <p>
            Perché un immobile non perde valore quando ha un problema. Lo perde quando quel problema
            emerge a trattativa avviata, davanti a un compratore che a quel punto non tratta più sul
            prezzo: tratta sull'incertezza. <span className="italic text-[#7D2E3F]">La valorizzazione
            non è alzare il prezzo. È togliere all'immobile le ragioni per cui verrebbe svalutato.</span>
          </p>
          <p>
            <span className="text-[#7D2E3F]">Pronto alla Vendita</span> è lo standard: il percorso che
            un immobile completa — o non completa. Non è una promessa, è un esito.
          </p>
          <p>
            <span className="text-[#7D2E3F]">RX CASA</span> è chi lo ha creato e chi lo attribuisce.
            Un terzo che non vende: è questo che rende l'esito credibile. Chi ha interesse a vendere
            non può certificare. Noi non vendiamo, quindi possiamo dichiarare.
          </p>
          <p>
            Dietro c'è trent'anni di sviluppo immobiliare, dal cantiere al rogito. Il mestiere di chi
            le case le ha costruite, vendute, e viste perdere valore in trattativa per un problema che
            nessuno aveva verificato — né risolto — prima di metterle sul mercato.
          </p>
          <p className="font-serif text-2xl text-[#7D2E3F] pt-6 border-t border-[#E6E4E0] mt-10">
            Abbiamo creato lo standard che avremmo voluto trovare.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
